import MisSystemWritebackStatus, {
} from "root/s360components/Registration/MisSystemWritebackStatus";
import {Fragment, useEffect, useState} from "react";
import {getMisWritebackEnabled} from "root/DataFunctions/RegistrationDataFns";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import {getDataFromResponse} from "root/globals";

export const WritebackEnabled = 'Y';
const MisSystemWritebackStatusManager = ({school_id, data}) =>
{
    const [schoolData, setSchoolData] = useState({data: [], isLoading: true})

    useEffect(() =>
    {
        getMisWritebackEnabled(school_id, (response) =>
        {
            const data = getDataFromResponse(response)[0];
            setSchoolData({data: data, isLoading: false});
        })
    },[]);

    const showMisStatus = schoolData.isLoading === false && schoolData.data !== undefined && schoolData.data.writeback_enabled === WritebackEnabled;

    return (
        <Fragment>
            {showMisStatus && <MisSystemWritebackStatus mis_writeback_id={data.writeback_id} mis_writeback_status={data.mis_writeback_status} registered={data.registered} datetime_logged={data.datetime_logged}/>}
        </Fragment>
    )
}

export default MisSystemWritebackStatusManager;